module.exports = __webpack_public_path__ + "static/media/folder.761b8bb6.png";